import AdminInvoices from "../symbols/getAdminInvoices";
interface AdminInvoiceResponseModelList {
  OrderId: string;
  OrderNo: number;
  InvoiceNo: string;
  OrderDate: Date;
  InvoiceDate: Date;
};

export interface AdminInvoiceGroupResponseModel {
  OrderNo: number;
  Invoices: AdminInvoiceResponseModelList[];
};
export interface AdminInvoiceListResponseModel {
  InvoiceGroups: AdminInvoiceGroupResponseModel[];
  Page: number;
  Size: number;
  Total: number;
}
interface State {
  data: AdminInvoiceListResponseModel;
  loading: boolean;
  error: any;
}
const initialState: State = {
  data: { InvoiceGroups: [], Page: 0, Size: 0, Total: 0 },
  loading: false,
  error: false,
};

function AdminInvoicesReducer(state: State = initialState, action: any) {
  switch (action.type) {
    case AdminInvoices.ADMIN_INVOICES:
      return { ...state, loading: true, error: false };
    case AdminInvoices.ADMIN_INVOICES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result as AdminInvoiceListResponseModel,
        loading: false,
        error: false,
      };
    case AdminInvoices.ADMIN_INVOICES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case AdminInvoices.CLEAR_ADMIN_INVOICES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default AdminInvoicesReducer;
